module.exports = __webpack_public_path__ + "img/13.0e4a63f0.png";